<template>
  <div class="container_box details_box_styles">
    <!--返回按钮-->
    <div class="go_back" @click="goBackBtn">
      <Icon class="back_icon" type="ios-arrow-back"/>
      <span class="back_txt">{{ $t('key1002627') }}</span>
    </div>
    <!--基本信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1000929') }}</h2>
        </template>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1004173') }}</span>
            <span class="basic_txt">{{ detailsData.supplierPickupOrderNumber }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1004174') }}</span>
            <span class="basic_txt">{{ detailsData.storageTypeName }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1004175') }}</span>
            <span class="basic_txt">{{ detailsData.thirdPickupOrderNumber }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1001522') }}</span>
            <span class="basic_txt">{{ detailsData.statusTxt }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1001180') }}</span>
            <span class="basic_txt">{{ detailsData.createdTime }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1004123') }}</span>
            <span class="basic_txt">{{ detailsData.pickupTime }}</span>
          </Col>
          <Col :span="ItemCol" class="basic_item">
            <span class="basic_title">{{ $t('key1001495') }}</span>
            <span class="ellipsis_1" :title="detailsData.remark">{{ detailsData.remark }}</span>
          </Col>
        </Row>
      </Card>
    </div>
    <!--提单申明数量及实际到仓数量-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1004176') }}</h2>
        </template>
        <template v-if="saleOrderData.length > 0">
          <div class="flex justify-content-between align-items-center mb10">
            <h3 class="font-size-14">{{ $t('key1004177') }}</h3>
          </div>
          <div class="table_box">
            <Table
              border
              max-height="400"
              :columns="tableColumns"
              :data="saleOrderData"
              :span-method="handleSpan">
            </Table>
            <Page
              :transfer="true"
              :total="saleOrderTotal"
              @on-change="saleOrderChangePage"
              show-total
              :page-size="saleOrderPageParams.pageSize"
              show-elevator
              :current="saleOrderPageParams.pageNum"
              show-sizer
              @on-page-size-change="saleOrderChangePageSize"
              placement="top"
              :page-size-opts="pageArray">
            </Page>
          </div>
        </template>
        <template v-if="stockListData.length > 0">
          <h3 class="mb10 mt30 font-size-14">{{ $t('key1004178') }}</h3>
          <div class="table_box">
            <Table
              border
              max-height="400"
              :columns="tableColumns"
              :data="stockListData"
              :span-method="handleSpan">
            </Table>
            <Page
              :transfer="true"
              :total="stockTotal"
              @on-change="stockChangePage"
              show-total
              :page-size="stockPageParams.pageSize"
              show-elevator
              :current="stockPageParams.pageNum"
              show-sizer
              @on-page-size-change="stockChangePageSize"
              placement="top"
              :page-size-opts="pageArray">
            </Page>
          </div>
        </template>
        <h3 class="mb10 mt30 font-size-14">
          <span>{{ $t('key1004179') }}</span>
          <Tooltip
            max-width="400"
            placement="top"
            class="ml5 cursor"
            transfer
            :content="$t('key1004171') + `${configCharacters()}` + $t('key1004172')">
            <Icon size="17" type="md-help-circle"/>
          </Tooltip>
        </h3>
        <Table
          border
          max-height="400"
          :columns="otherColumns"
          :data="shipmentsQuantityData"
          :span-method="handleSpan">
        </Table>
      </Card>
    </div>
    <!--操作日志-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1000288') }}</h2>
        </template>
        <div class="input_box">
          <Input :placeholder="$t('key1002015')" style="width: 450px;" v-model.trim="remarks"></Input>
          <Button type="primary" style="margin-left: 15px;" @click="remarksBtn">{{ $t('key1000350') }}</Button>
        </div>
        <div class="table_box">
          <Table
            highlight-row
            border
            max-height="650"
            :loading="tableLoading"
            :columns="operationLogColumns"
            :data="operationLogData">
          </Table>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {
  commonCopyContent,
  getAllYmsWarehouseData,
  getUserNameByUserId,
  isJSON,
  setConfigCharacters,
  getWarehouseName,
  getAllUsersInfo,
  getDataSetBatchList,
  getEnumName
} from "@/utils/common";

const STORAGE_HIDE_KEYS = ['subPackageCode', 'warehouseName', 'expressageNo', 'status'];

export default {
  name: 'billLadingManageDetails',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      ItemCol: 6,
      pageParamsStatus: false,
      detailsData: {},
      remarks: '',
      operationLogData: [],
      saleOrderData: [],
      stockListData: [],
      shipmentsQuantityData: [],
      saleOrderTotal: 0,
      stockTotal: 0,
      ymsWarehouseList: [],
      userInfoList: {},
      enumData: [],
      saleOrderPageParams: {
        ymsSubPackageStatus: null,
        ymsPickupOrderId: v.$route.query.ymsPickupOrderId,
        outboundTypes: [1, 5, 6, 7],
        pageNum: 1,
        pageSize: 15,
      },
      stockPageParams: {
        ymsSubPackageStatus: null,
        ymsPickupOrderId: v.$route.query.ymsPickupOrderId,
        outboundTypes: [2, 3],
        pageNum: 1,
        pageSize: 15,
      },
      baseTableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522'),
          key: 'subPackageCode',
          align: 'left',
          minWidth: 130,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004168'),
          key: 'warehouseName',
          align: 'left',
          minWidth: 130,
          render: (h, params) => {
            return h('span', getWarehouseName(v.ymsWarehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'expressageNo',
          minWidth: 130,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 320,
          key: 'goodsInfo',
          align: 'left',
          render: (h, params) => {
            const productInfo = params.row._productInfo;
            if (!productInfo) return;

            const spuInfo = productInfo._spuInfo || {};
            const specList = productInfo.productGoodsSpecificationList || [];
            const spec = specList.map(i => i.name + '：' + i.value).join('、');
            const imgPath = productInfo.primaryImage || spuInfo.primaryImage || '';
            const supplierSku = productInfo.supplierSku || '';
            const ymsSku = productInfo.ymsSku || '';

            return h('div', {class: 'flex mt5'}, [
              v.tableImg(h, params, null, imgPath),
              h('div', {class: 'ml10 flex flex-direction'}, [
                h('Alink', {
                  props: {
                    linkName: spuInfo.name,
                    textAlign: 'left',
                  },
                  on: {
                    AlinkBtn: () => {
                      const {href} = v.$router.resolve({
                        path: '/productDetails',
                        query: {
                          type: 'look',
                          productId: productInfo.ymsProductId,
                          supplierMerchantId: spuInfo.supplierMerchantId
                        }
                      });
                      window.open(href, '_blank');
                    }
                  }
                }),
                h('p', {class: 'flex align-items-center mt5'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003976') + supplierSku),
                  h('Icon', {
                    props: {
                      type: 'ios-copy-outline',
                      size: 18,
                      color: '#01a6ee'
                    },
                    class: 'ml10 cursor',
                    attrs: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003')},
                    on: {
                      click: () => commonCopyContent(supplierSku, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001286'))
                    }
                  })
                ]),
                h('p', {class: 'flex align-items-center mt5'}, [
                  h('span', `${setConfigCharacters(false)}SKU：` + ymsSku),
                  h('Icon', {
                    props: {
                      type: 'ios-copy-outline',
                      size: 18,
                      color: '#01a6ee'
                    },
                    class: 'ml10 cursor',
                    attrs: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003')},
                    on: {
                      click: () => commonCopyContent(ymsSku, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001286'))
                    }
                  })
                ]),
                h('p', {class: 'mt5 mb5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240') + spec)
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          minWidth: 130,
          align: 'center',
          render: (h, params) => {
            const statusTxt = getEnumName(v.enumData, 'YmsSubPackageInfoStatusCoreEnum', params.row.status, 'number');
            return h('div', statusTxt);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
          key: 'quantity',
          minWidth: 130,
          align: 'left',
          render: (h, params) => h('p', params.row.quantity)
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004167')}`,
          key: 'actualSortingNumber',
          align: 'left',
          minWidth: 160,
          render: (h, params) => {
            const {quantity, actualSortingNumber} = params.row;
            if ([2, 3, 4, 5, 21].includes(v.detailsData.status)) {
              return h('Alink', {
                props: {
                  AlinkShow: false,
                  linkName: actualSortingNumber,
                  textAlign: 'left',
                  styles: {
                    color: actualSortingNumber !== quantity ? '#D9001B' : '#333'
                  }
                }
              });
            }
            return h('span', '-');
          }
        },
      ],
      operationLogColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'updatedBy',
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004169'),
          key: 'content',
          align: 'center',
          render(h, params) {
            const {content, logContent} = params.row;
            if (!content) return;

            if (isJSON(content) || logContent) {
              if (Array.isArray(logContent)) {
                return h('div', logContent.map(item => h('p', {class: 'mt3 mb3'}, item)));
              }
              return h('p', {class: 'mt5 mb5'}, logContent);
            }

            return h('div', {
              domProps: {
                innerHTML: content.replace(/;/g, '<br/>')
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000291'),
          key: 'updatedTime',
          align: 'center',
          sortable: true,
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.updatedTime, 'fulltime'));
          }
        }
      ]
    };
  },
  computed: {
    /**
     * @description: 根据 storageType 是否需要隐藏部分列表字段
     * @return {Boolean}
     */
    isHideStorageColumns() {
      return [3, 4].includes(this.detailsData.storageType);
    },

    /**
     * @description: 需要动态隐藏的字段 key 集合
     * 当 detailsData.storageType 为 3、4 时，隐藏：
     * 订单号、目的仓库、运单号、状态
     * @return {Array}
     */
    hiddenColumnKeys() {
      return this.isHideStorageColumns ? STORAGE_HIDE_KEYS : [];
    },

    /**
     * @description: 销售订单、备货单表格字段
     * 根据 storageType 动态过滤列表字段
     * @return {Array}
     */
    tableColumns() {
      return this.getFilteredColumns();
    },

    /**
     * @description: 多发货品数量表格字段
     * 根据 storageType 动态过滤列表字段
     * @return {Array}
     */
    otherColumns() {
      return this.getFilteredColumns(['expressageNo', 'status']);
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    /**
     * @description: 根据隐藏字段 key 过滤表格字段
     * 默认根据当前 storageType 动态隐藏字段，
     * 也支持额外传入 extraHideKeys 进行扩展
     * @param {Array} extraHideKeys 额外需要隐藏的字段 key 列表
     * @return {Array}
     */
    getFilteredColumns(extraHideKeys = []) {
      const hideKeys = [...this.hiddenColumnKeys, ...extraHideKeys];
      return this.baseTableColumns.filter(item => !hideKeys.includes(item.key));
    },

    /**
     * @description: 初始化页面数据
     * 1. 获取枚举数据
     * 2. 获取仓库数据
     * 3. 获取用户数据
     * 4. 并发获取销售订单、备货单、详情数据
     * @return {Promise<void>}
     */
    async initFun() {
      const enumKeyList = [
        'YmsPickupOrderStatusCoreEnum',
        'YmsSubPackageInfoStatusCoreEnum',
        'StorageTypeCoreEnum'
      ];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.ymsWarehouseList = await getAllYmsWarehouseData();
      this.userInfoList = await getAllUsersInfo();
      await Promise.all([
        this.getOrderListData('sale'),
        this.getOrderListData('stock'),
        this.getDetailsData()
      ]);
    },
    /**
     * @description: 返回列表页
     */
    goBackBtn() {
      this.$router.push('/billLadingManage');
    },
    /**
     * @description: 获取提单详情数据
     * 主要处理：
     * 1. 基本信息
     * 2. 状态、时间、提单类型格式化
     * 3. 操作日志数据
     * 4. 多发货品数量数据
     * @return {Promise<void>}
     */
    async getDetailsData() {
      if (!this.getPermission('ymsPickupOrder_detail')) {
        this.gotoError();
        return;
      }
      const query = {
        ymsPickupOrderId: this.$route.query.ymsPickupOrderId,
        ymsSubPackageStatus: null
      };
      this.tableLoading = true;
      try {
        const response = await this.axios.post(api.post_ymsPickupOrder_detail, query);
        if (response.data.code !== 0) return;
        const data = response.data.datas || {};
        // 状态、时间、提单类型格式化
        data.statusTxt = getEnumName(this.enumData, 'YmsPickupOrderStatusCoreEnum', data.status, 'number');
        data.createdTime = data.createdTime ? this.$uDate.dealTime(data.createdTime, 'fulltime') : '';
        data.pickupTime = data.pickupTime ? this.$uDate.dealTime(data.pickupTime, 'fulltime') : '';
        data.storageTypeName = getEnumName(this.enumData, 'StorageTypeCoreEnum', data.storageType, 'number');
        this.detailsData = data;
        // 处理操作日志
        const ymsLogsList = data.ymsLogs || [];
        this.operationLogData = this.handleMultilingualLogs(ymsLogsList, this.system);
        // 处理多发货品数量
        const goodsList = data.ymsSubPackageInfoToGoodsBos || [];
        if (!goodsList.length) {
          this.shipmentsQuantityData = [];
          return;
        }
        const ymsProductGoodsIds = goodsList.map(item => item.ymsProductGoodsId).filter(Boolean);
        this.shipmentsQuantityData = ymsProductGoodsIds.length ? await this.getProductInfoByIds(ymsProductGoodsIds, goodsList) : [];
      } finally {
        this.tableLoading = false;
      }
    },

    /**
     * @description: 获取销售订单 / 备货单列表数据
     * 根据 type 区分请求哪一类数据：
     * sale  -> 销售订单
     * stock -> 备货单
     * @param {String} type 数据类型 sale | stock
     * @return {Promise<void>}
     */
    async getOrderListData(type) {
      const isSale = type === 'sale';
      const pageParams = isSale ? this.saleOrderPageParams : this.stockPageParams;
      const totalKey = isSale ? 'saleOrderTotal' : 'stockTotal';
      const dataKey = isSale ? 'saleOrderData' : 'stockListData';
      this[dataKey] = [];
      const response = await this.axios.post(api.post_ymsPickupOrderDetail_queryPickOrderDetail, pageParams);
      if (response.data.code !== 0) return;
      const data = response.data.datas || {};
      const list = data.list || [];
      this[totalKey] = data.total || 0;
      const ymsProductGoodsIds = list.map(item => item.ymsProductGoodsId).filter(Boolean);
      this[dataKey] = ymsProductGoodsIds.length ? await this.getProductInfoByIds(ymsProductGoodsIds, list) : [];
    },

    /**
     * @description: 销售订单分页切换
     * @param {Number} page 当前页码
     */
    saleOrderChangePage(page) {
      this.saleOrderPageParams.pageNum = page;
      this.getOrderListData('sale');
    },

    /**
     * @description: 销售订单分页条数切换
     * @param {Number} pageSize 每页条数
     */
    saleOrderChangePageSize(pageSize) {
      this.saleOrderPageParams.pageSize = pageSize;
      this.getOrderListData('sale');
    },

    /**
     * @description: 备货单分页切换
     * @param {Number} page 当前页码
     */
    stockChangePage(page) {
      this.stockPageParams.pageNum = page;
      this.getOrderListData('stock');
    },

    /**
     * @description: 备货单分页条数切换
     * @param {Number} pageSize 每页条数
     */
    stockChangePageSize(pageSize) {
      this.stockPageParams.pageSize = pageSize;
      this.getOrderListData('stock');
    },

    /**
     * @description: 添加备注
     * 校验备注内容非空后，调用备注接口，成功后刷新详情数据
     */
    remarksBtn() {
      if (!this.remarks) {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004170'));
        return;
      }

      const query = {
        content: this.remarks,
        businessId: this.$route.query.ymsPickupOrderId
      };

      this.axios.post(api.post_ymsPickupOrder_createNote, query).then(response => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          this.getDetailsData();
        }
      });
    },

    /**
     * @description: 表格合并单元格
     * 当前逻辑只处理前两列的合并展示
     * 通过 row.length、row.currentIndex、row.tableLength 控制 rowspan
     * @param {Object} param0 表格当前单元格信息
     * @param {Object} param0.row 当前行数据
     * @param {Number} param0.rowIndex 当前行索引
     * @param {Number} param0.columnIndex 当前列索引
     * @return {Array|undefined}
     */
    handleSpan({row, rowIndex, columnIndex}) {
      const columnList = [0, 1];
      if (!columnList.includes(columnIndex)) return;
      if (row.length > 1) {
        if (rowIndex === row.currentIndex) {
          return [row.length, 1];
        }
        for (let i = 0; i <= row.tableLength; i++) {
          if (rowIndex === i) {
            return [0, 0];
          }
        }
      }
    },
  },
  watch: {
    pageParamsStatus(value) {
      if (value) {
        this.getDetailsData();
        this.pageParamsStatus = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.basic_information_box {
  .select_dropDown {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .label_txt {
      width: 70px;
      display: inline-block;
    }

    /deep/ .ivu-select {
      width: 160px;
    }
  }

  .input_box {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
}
</style>